import React, { useState, useEffect } from 'react';
import { Alert, Button, ListGroup } from 'react-bootstrap';
import Form from 'react-bootstrap/Form';
import { getActiveEmployees } from "../../services/EmployeesService";
import EmployeeVacations from "./EmployeeVacations";

function SearchUserForm() {

    const [userEmail, setUserEmail] = useState("");
    const [userId, setUserId] = useState("");
    const [userName, setUserName] = useState("");
    const [isValidEmail, setIsValidEmail] = useState(true);
    const [suggestions, setSuggetions] = useState([]);
    const [usersList, setUsersList] = useState([]);
    const [users, setUsers] = useState([]);

    const [showError, setShowError] = useState(false);
    const handleCloseError = () => setShowError(false);
    const handleShowError = () => {
        setShowError(true);
    }

    const handleChangeEmail = (e) => {
        setUserEmail(e.target.value);
        setIsValidEmail(e.target.value.endsWith('@qualt.io'));
        const newSuggestions = usersList.filter((valor) =>
            valor.toLowerCase().startsWith(e.target.value.toLowerCase())
        );
        setSuggetions(newSuggestions);
    };

    const selectSuggestion = (suggestions) => {
        setUserEmail(suggestions);
        setIsValidEmail(true);
        setSuggetions([]);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isValidEmail) {
            const findObject = users.find((object) => object.email === userEmail);
            console.log(users);

            if (findObject) {
                console.log('Entro aquí');
                setUserId(findObject.id);
                setUserName(findObject.name);
            } else {
                handleShowError();
            }
        }
    }

    const handleBackClick = () => {
        setUserId(null);
        setUserName(null);
    }

    const getUserList = async () => {
        let res = await getActiveEmployees();
        let emails = [];
        let users = [];
        for (const key in res) {
            emails.push(res[key].email);
            users.push(
                {
                    email: res[key].email,
                    id: res[key].id,
                    name: res[key].name + " " + res[key].last_name
                }
            );
        }
        setUsers(users);
        return emails;
    }

    useEffect(() => {
        getUserList().then((data) => {
            setUsersList(data);
        })
    }, [])

    return (
        <div>
            {userId ? (
                <div>
                    <div className="container">
                        <div className="container-fluid title">
                            <div className="row">
                                <div className="col-md-3">
                                <a onClick={handleBackClick} href="/formulario_usuarios" style={{cursor: "pointer", color: "blue"}}><svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
                                    <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"></path>
                                </svg>
                                    
                                Búsqueda de usuarios
                                </a>
                                </div>
                                <div className="col-md-9">
                                    <h3>{userName}</h3>
                                </div>
                            </div>
                        </div>
                    </div>
                    <EmployeeVacations userId={userId}/>
                </div>
            ) : (
                <div className="container home">
                    <Alert variant="danger" show={showError} onClose={handleCloseError} dismissible>
                        <p>
                        Se ha producido un error.
                        </p>
                    </Alert>
                    <h1 className="font-weight-light">Buscar usuario</h1>
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="formBasicId">
                        <Form.Label>Email del usuario</Form.Label>
                        <Form.Control 
                            required
                            placeholder="Email" 
                            value={userEmail}
                            onChange={handleChangeEmail}
                            isInvalid={!isValidEmail}
                        />
                        <ListGroup as="ul">
                            {suggestions.map((suggestion, index) => (
                                <ListGroup.Item action as="li" key={index} onClick={() => selectSuggestion(suggestion)}>
                                {suggestion}
                                </ListGroup.Item>
                            ))}
                        </ListGroup>

                        <Form.Control.Feedback type="invalid">
                            Por favor indica un email de usuario válido.
                        </Form.Control.Feedback>
                        </Form.Group>

                        <Button variant="primary" type="submit">
                            Buscar
                        </Button>
                    </Form>
                </div>
            )}
        </div>
    );
}

export default SearchUserForm;